/* Les simulations de police sont dans assets/meora-font-sim.js (chargees sur toutes les pages). */

(function () {
  'use strict';

  /* ---------- Taille de la galerie sur ordinateur ----------
     Bord droit de la photo = fin du A du logo MEORA, sans depasser la hauteur de l'ecran
     (on garde au moins 56px pour voir le haut de la photo suivante). La galerie descend jusqu'en bas de l'ecran.
     Les valeurs sont posees sur .meora-pdp (la grille) pour que la colonne d'infos se decale toujours correctement. */
  function findLogo() {
    var imgs = document.querySelectorAll('header img, a[href="/"] img');
    for (var i = 0; i < imgs.length; i++) {
      var b = imgs[i].getBoundingClientRect();
      if (b.width > 60 && b.top + window.pageYOffset < 200) return imgs[i];
    }
    return null;
  }

  function sizeGallery(pdp, gal) {
    if (!window.matchMedia('(min-width: 1024px)').matches) {
      pdp.style.removeProperty('--gal-w');
      pdp.style.removeProperty('--gal-h');
      pdp.style.removeProperty('--gal-total');
      return;
    }
    var multi = gal.classList.contains('meora-gal--multi');
    var thumbsSpace = multi ? 116 : 0;
    var ratio = parseFloat(gal.style.getPropertyValue('--meora-gal-ratio')) || 1;
    var vh = window.innerHeight;
    var galTop = pdp.getBoundingClientRect().top + window.pageYOffset + 24;
    var h = Math.max(360, Math.round(vh - galTop));
    var w = (multi ? h - 40 : h) * ratio;
    /* OCT 2026 : photo agrandie - on n'est plus limite par le logo, seulement par la colonne d'infos (440px mini). */
    var vw = window.innerWidth, pad = vw >= 1440 ? 48 : 32;
    var avail = vw - 2 * pad - thumbsSpace - 56 - 440;
    if (avail > 300) w = Math.min(w, avail);
    w = Math.round(w);
    /* OCT 2026 : on ne montre le haut de la photo suivante (jusqu'en bas de l'ecran) que s'il reste une fine bande ;
       sinon (petit ecran, photo limitee en largeur) on ne montre que la photo, sans bande blanche dessous. */
    if (multi && h - w / ratio > 90) h = Math.round(w / ratio);
    pdp.style.setProperty('--gal-w', w + 'px');
    pdp.style.setProperty('--gal-h', h + 'px');
    pdp.style.setProperty('--gal-total', (w + thumbsSpace) + 'px');
  }

  /* ---------- Galerie (ordinateur : defilement vertical / mobile : carrousel horizontal) ---------- */
  function setupGallery(pdp) {
    var gal = pdp.querySelector('[data-meora-gallery]');
    if (!gal) return;
    var main = gal.querySelector('[data-meora-gal-main]');
    if (!main) return;

    sizeGallery(pdp, gal);
    window.addEventListener('load', function () { sizeGallery(pdp, gal); });

    /* Le haut de la photo suivante ne sert d'indice qu'en arrivant sur la page :
       des que la page defile, il disparait (classe meora-gal--compact). */
    function updateCompact() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      gal.classList.toggle('meora-gal--compact', y > 8);
    }
    window.addEventListener('scroll', updateCompact, { passive: true });
    updateCompact();

    var slides = Array.prototype.slice.call(main.querySelectorAll('.meora-gal__slide'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.meora-gal__thumb'));
    var bars = Array.prototype.slice.call(gal.querySelectorAll('.meora-gal__bar'));
    var list = gal.querySelector('[data-meora-gal-thumbs]');
    var next = gal.querySelector('[data-meora-gal-next]');
    var current = parseInt(gal.getAttribute('data-start') || '0', 10) || 0;

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        sizeGallery(pdp, gal);
        if (slides.length > 1) goTo(current, false);
      }, 150);
    });

    if (slides.length < 2) return;

    function isVertical() {
      return window.getComputedStyle(main).scrollSnapType.indexOf('y') === 0;
    }

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        if (k === i) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
      bars.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
      if (next) next.disabled = i === slides.length - 1;
      if (list && thumbs[i] && list.scrollHeight > list.clientHeight) {
        var t = thumbs[i];
        var top = t.offsetTop - (list.clientHeight - t.offsetHeight) / 2;
        list.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
      }
    }

    function goTo(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var s = slides[i];
      var behavior = smooth === false ? 'auto' : 'smooth';
      if (isVertical()) {
        main.scrollTo({ top: s.offsetTop, behavior: behavior });
      } else {
        main.scrollTo({ left: s.offsetLeft, behavior: behavior });
      }
      setActive(i);
    }

    var pending = false;
    main.addEventListener('scroll', function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        var i = isVertical()
          ? Math.round(main.scrollTop / Math.max(1, slides[0].offsetHeight))
          : Math.round(main.scrollLeft / Math.max(1, slides[0].offsetWidth));
        i = Math.max(0, Math.min(slides.length - 1, i));
        if (i !== current) setActive(i);
      }, 50);
    }, { passive: true });

    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function (e) { e.preventDefault(); goTo(k); });
    });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); goTo(current + 1); });

    /* Changement de variante : afficher la photo de la variante */
    if (window.Events && typeof window.Events.on === 'function') {
      window.Events.on('variantchange:image', function (id) {
        if (id === null || id === undefined) return;
        for (var k = 0; k < slides.length; k++) {
          if (slides[k].getAttribute('data-media-id') === String(id)) { goTo(k); break; }
        }
      });
    }

    setActive(current);
    if (current > 0) {
      goTo(current, false);
      window.addEventListener('load', function () { goTo(current, false); });
    }
  }

  /* ---------- Tiroir guide des tailles ---------- */
  function setupDrawer(pdp, id) {
    var drawer = document.querySelector('[data-meora-drawer="' + id + '"]');
    if (!drawer) return;
    if (drawer.parentNode !== document.body) document.body.appendChild(drawer);
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('meora-lock');
      void drawer.offsetWidth;
      setTimeout(function () { drawer.classList.add('is-open'); }, 20);
      var closeBtn = drawer.querySelector('.meora-drawer__close');
      if (closeBtn) setTimeout(function () { closeBtn.focus(); }, 60);
    }
    function close() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('meora-lock');
      setTimeout(function () { drawer.hidden = true; }, 350);
      if (lastFocus) lastFocus.focus();
    }

    pdp.addEventListener('click', function (e) {
      if (e.target.closest('[data-meora-drawer-open]')) { e.preventDefault(); open(); }
    });
    drawer.querySelectorAll('[data-meora-drawer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) close();
    });
  }

  function placeSizeGuide(pdp) {
    var wrap = pdp.querySelector('[data-meora-size-guide]');
    if (!wrap) return;
    var btn = wrap.querySelector('button');
    var labels = pdp.querySelectorAll('.swatches__option-name');
    for (var i = 0; i < labels.length; i++) {
      var nameEl = labels[i].querySelector('.swatches__option-label') || labels[i];
      if (/taille|size|longueur/i.test(nameEl.textContent)) {
        labels[i].appendChild(btn);
        wrap.remove();
        return;
      }
    }
  }

  /* ---------- Encadre qui defile ---------- */
  function setupReassurance(pdp) {
    pdp.querySelectorAll('[data-meora-reassure]').forEach(function (box) {
      var slides = box.querySelectorAll('.meora-reassure__slide');
      var dots = box.querySelectorAll('.meora-reassure__dot');
      if (slides.length < 2) return;
      var index = 0;
      var timer = null;
      function show(n) {
        index = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
          d.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }
      function stop() { if (timer) clearInterval(timer); }
      function start() { stop(); timer = setInterval(function () { show(index + 1); }, 4000); }
      dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); start(); }); });
      box.addEventListener('mouseenter', stop);
      box.addEventListener('mouseleave', start);
      start();
    });
  }

  /* ---------- Taille a choisir (aucune taille preselectionnee) ----------
     Le petit script de snippets/product-variants.liquid decoche la taille au chargement (sauf ?variant= dans l'adresse)
     et marque le bloc de la taille [data-meora-size]. Ici : tant qu'aucune taille n'est choisie, l'ajout au panier
     (bouton principal, barre collante, paiement express) est bloque et le message s'affiche sous les tailles.
     Si une autre option (Matiere...) change avant la taille, on laisse le theme calculer prix / photo / disponibilite
     avec une taille provisoire, puis on la decoche aussitot. */
  function setupSizeRequired(pdp) {
    var wrap = pdp.querySelector('[data-meora-nosize]');
    if (!wrap) return;
    var sizeBox = wrap.querySelector('.swatches__container[data-meora-size]');
    if (!sizeBox) return;
    var sizeInputs = Array.prototype.slice.call(sizeBox.querySelectorAll('.swatches__form--input'));
    if (!sizeInputs.length) return;
    var valueEl = sizeBox.querySelector('.swatches__option-value');
    var buttons = pdp.querySelector('.meora-pdp__buttons');
    var section = pdp.closest('[data-section-type="product"]') || document;
    var product = null;
    try {
      var json = section.querySelector('.product-json');
      if (json) product = JSON.parse(json.textContent || '{}');
    } catch (err) { product = null; }

    function checkedSize() {
      for (var i = 0; i < sizeInputs.length; i++) { if (sizeInputs[i].checked) return sizeInputs[i]; }
      return null;
    }
    var chosen = !!checkedSize();
    if (chosen && valueEl && !valueEl.textContent.trim()) valueEl.textContent = checkedSize().value;

    var msg = document.createElement('p');
    msg.className = 'meora-size-msg';
    msg.setAttribute('role', 'alert');
    msg.setAttribute('data-meora-corps', '1');
    msg.textContent = 'Veuillez choisir votre taille.';
    sizeBox.appendChild(msg);

    /* L'identifiant de variante envoye au panier ne doit pas valoir la 1re taille par defaut */
    function clearVariantInput() {
      var input = buttons && buttons.querySelector('#formVariantId');
      if (input) input.value = '';
    }
    if (!chosen) clearVariantInput();

    function dropVariantFromUrl() {
      try {
        var url = new URL(window.location.href);
        if (!url.searchParams.has('variant')) return;
        url.searchParams.delete('variant');
        window.history.replaceState({}, '', url.pathname + url.search + url.hash);
      } catch (err) {}
    }

    function showMsg() {
      msg.classList.add('is-visible');
      var r = sizeBox.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.top < 90 || r.bottom > vh - 110) {
        sizeBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function block(e) {
      if (chosen) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      showMsg();
    }

    /* Phase de capture : passe avant le script du panier (assets/cart.js, clic sur .js-ajax-submit).
       La barre collante declenche un clic sur le bouton principal : elle est donc bloquee aussi. */
    if (buttons) {
      pdp.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest || !buttons.contains(t)) return;
        if (t.closest('.js-ajax-submit, [type="submit"], .shopify-payment-button')) block(e);
      }, true);
      pdp.addEventListener('submit', function (e) {
        if (buttons.contains(e.target)) block(e);
      }, true);
    }

    /* Taille provisoire : la taille disponible pour les autres options choisies (sinon la 1re) */
    function pickSize() {
      var pos = parseInt(sizeBox.getAttribute('data-option-index'), 10) - 1;
      var selected = {};
      wrap.querySelectorAll('.swatches__container').forEach(function (c) {
        if (c === sizeBox) return;
        var p = parseInt(c.getAttribute('data-option-index'), 10) - 1;
        var inp = c.querySelector('.swatches__form--input:checked');
        if (inp) selected[p] = inp.value;
      });
      var variants = (product && product.variants) || [];
      var fallback = null;
      for (var i = 0; i < sizeInputs.length; i++) {
        for (var j = 0; j < variants.length; j++) {
          var v = variants[j];
          if (!v || !v.options || v.options[pos] !== sizeInputs[i].value) continue;
          var ok = true;
          for (var k in selected) { if (v.options[k] !== selected[k]) { ok = false; break; } }
          if (!ok) continue;
          if (v.available) return sizeInputs[i];
          if (!fallback) fallback = sizeInputs[i];
        }
      }
      return fallback || sizeInputs[0];
    }

    wrap.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.classList || !t.classList.contains('swatches__form--input')) return;
      if (sizeBox.contains(t)) {
        chosen = true;
        msg.classList.remove('is-visible');
        return;
      }
      if (chosen) return;
      var pick = pickSize();
      if (!pick) return;
      pick.checked = true;
      setTimeout(function () {
        if (chosen) return;
        sizeInputs.forEach(function (i) { i.checked = false; });
        if (valueEl) valueEl.textContent = '';
        clearVariantInput();
        dropVariantFromUrl();
      }, 0);
    }, true);
  }

  /* ---------- Matiere choisie (sur-titre + 1re caracteristique) ----------
     sections/main-product-meora.liquid pose data-meora-matiere="<position de l'option Matiere, 1, 2 ou 3>" sur les
     elements a mettre a jour (uniquement si le produit a une option Matiere / Metal / Material). A chaque changement
     d'option, on y recopie la valeur cochee de cette option (pastilles) ou choisie (liste deroulante). */
  function setupMatiere(pdp) {
    var outs = pdp.querySelectorAll('[data-meora-matiere]');
    if (!outs.length) return;
    var pos = parseInt(outs[0].getAttribute('data-meora-matiere'), 10);
    if (!(pos > 0)) return;

    function currentValue() {
      var box = pdp.querySelector('.swatches__container[data-option-index="' + pos + '"]');
      if (box) {
        var inp = box.querySelector('.swatches__form--input:checked');
        return inp ? inp.value : '';
      }
      var selects = pdp.querySelectorAll('select.js-variant-selector');
      if (selects[pos - 1]) return selects[pos - 1].value;
      return '';
    }
    function apply() {
      var v = currentValue();
      if (!v) return;
      outs.forEach(function (el) { if (el.textContent !== v) el.textContent = v; });
    }

    pdp.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.classList) return;
      if (!t.classList.contains('swatches__form--input') && !t.classList.contains('js-variant-selector')) return;
      apply();
      setTimeout(apply, 0);
    });
    apply();
  }

  /* ---------- Barre d'ajout collante ---------- */
  function setupSticky(pdp, id) {
    var sticky = document.querySelector('[data-meora-sticky="' + id + '"]');
    var mainWrap = pdp.querySelector('.meora-pdp__buttons');
    if (!sticky || !mainWrap) return;
    if (sticky.parentNode !== document.body) document.body.appendChild(sticky);
    var mainSubmit = mainWrap.querySelector('.js-ajax-submit');
    var btn = sticky.querySelector('[data-meora-sticky-btn]');
    var priceOut = sticky.querySelector('[data-meora-sticky-price]');
    var variantOut = sticky.querySelector('[data-meora-sticky-variant]');

    function setVisible(show) {
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) { sticky.removeAttribute('inert'); } else { sticky.setAttribute('inert', ''); }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        setVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainWrap);
    }

    btn.addEventListener('click', function () {
      if (mainSubmit && !mainSubmit.disabled) mainSubmit.click();
    });

    function sync() {
      var price = pdp.querySelector('#product-price');
      if (price && priceOut) {
        var onSale = price.classList.contains('price--on-sale');
        var p = price.querySelector(onSale ? '[data-sale-price]' : '.price__regular [data-regular-price]');
        if (p) priceOut.textContent = p.textContent.trim();
      }
      if (variantOut) {
        var vals = [];
        pdp.querySelectorAll('.swatches__option-value').forEach(function (s) {
          var t = s.textContent.trim();
          if (t) vals.push(t);
        });
        if (vals.length || pdp.querySelector('[data-meora-nosize]')) variantOut.textContent = vals.join(' / ');
      }
      if (mainSubmit) {
        btn.disabled = mainSubmit.disabled;
        if (mainSubmit.value) btn.textContent = mainSubmit.value;
      }
    }
    var info = pdp.querySelector('.meora-pdp__info');
    if (info && 'MutationObserver' in window) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; sync(); }, 60);
      }).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'value'] });
    }
    sync();
  }

  function init() {
    document.querySelectorAll('[data-meora-pdp]').forEach(function (pdp) {
      if (pdp.getAttribute('data-meora-ready')) return;
      pdp.setAttribute('data-meora-ready', '1');
      var id = pdp.getAttribute('data-meora-pdp');
      setupGallery(pdp);
      setupDrawer(pdp, id);
      placeSizeGuide(pdp);
      setupReassurance(pdp);
      setupSizeRequired(pdp);
      setupMatiere(pdp);
      setupSticky(pdp, id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('body > [data-meora-drawer], body > [data-meora-sticky]').forEach(function (el) { el.remove(); });
    init();
  });
})();
